<template>
  <CCard>
    <CCardBody class="card-body">
      <CRow>
        <div class="div_cards">
          <div
            class="div-cards-value-evolution"
            @click="bringOutstandingAmounts()"
          >
            <span id="rec"></span>
            <fieldset>
              <p class="title">
                Valores Pendentes
              </p>
              <p class="extra-info-title">
                {{ extraInformation.valor_total_pendente }}
              </p>
            </fieldset>
          </div>
          <div class="div-cards-value-evolution" @click="pendingQueries()">
            <span id="rec"></span>
            <fieldset>
              <p class="title">
                Evoluções Pendentes
              </p>
              <p class="extra-info-title">
                {{ extraInformation.total_evolucao_pendente }}
              </p>
            </fieldset>
          </div>
        </div>
      </CRow>
      <CRow>
        <!-- <dashboardQueryFilters /> -->
      </CRow>
      <CDataTable
        :items="pendencies"
        :fields="fieldsConsults"
        :noItemsView="not_found"
        column-filter
        hover
        searching
        sorter
        small
        :fixed="fixed"
        :items-per-page="10"
        :dark="dark"
        pagination
      >
        <template #item="{ item }">
          <td>
            <CBadge :color="getBadge(item.status)">{{ item.status }}</CBadge>
          </td>
        </template>

        <template #acao="{ item, index }">
          <td class="py-4">
            <CButton
              v-show="btn_ver"
              color="primary"
              variant="outline"
              square
              style="margin-top: -20px;"
              size="sm"
              @click="detalhar(item, index)"
              >VER</CButton
            >
          </td>
        </template>
      </CDataTable>
    </CCardBody>
  </CCard>
</template>
<script>
import moment from "moment";

export default {
  name: "ppr",
  data() {
    return {
      not_found: {
        noResults: "Nenhum registro encontrado",
        noItems: "Nenhum registro encontrado",
      },
      checkOptions: false,
      hover: true,
      striped: true,
      bordered: false,
      small: true,
      fixed: true,
      dark: false,
      optionsCards: [],

      fieldsConsults: [
        { key: "patient", label: "Paciente", _style: "min-width:200px" },
        {
          key: "email",
          label: "Email",
          _style: "min-width:100px;",
          sorter: false,
          filter: false,
        },
        {
          key: "date_at",
          label: "Data",
          _style: "min-width:40px;",
          filter: false,
        },
        {
          key: "hour_at",
          label: "Hora",
          _style: "min-width:40px;",
          filter: false,
        },
        {
          key: "paymentform",
          label: "Pagamento",
          _style: "min-width:40px;",
          sorter: false,
          filter: false,
        },
        {
          key: "tipo_servico",
          label: "Serviço",
          _style: "min-width:40px;",
          sorter: false,
          filter: false,
        },
        { key: "item", label: "Status", sorter: false, filter: false },
        { key: "acao", label: "", sorter: false, filter: false },
      ],

      extraInformation: {
        valor_total_pendente: "",
        total_evolucao_pendente: "",
      },
      pendencies: [],
      btn_ver: false,
      count: 0,
    };
  },
  methods: {
    getBadge(status) {
      return status == "Criada"
        ? "primary"
        : status === "Não Compareceu"
        ? "warning"
        : status === "Evolucao"
        ? "info"
        : status === "Sem Protocolo"
        ? "warning"
        : status === "Finalizada"
        ? "success"
        : "primary";
    },
    bringOutstandingAmounts() {
      let id = localStorage.getItem("id");
      this.pendencies.length = 0;

      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}lista-valores-pendentes/${id}`)
        .then((res) => res.json())
        .then((res) => {
          this.btn_ver = false;
          res.forEach((el) => {
            this.extraInformation.valor_total_pendente = el.valor;
            this.pendencies.push({
              patient: el.patient,
              email: el.email,
              date_at: el.date_at,
              hour_at: el.hour_at,
              paymentform: el.paymentform,
              tipo_servico: el.tipo_servico,
            });
          });
        });
    },
    pendingQueries() {
      let id = localStorage.getItem("id");
      this.pendencies.length = 0;

      this.count++;

      this.$http
        .get(
          `${process.env.VUE_APP_API_BASE_URL}lista-consultas-evolucao/${id}`
        )
        .then((res) => res.json())
        .then((res) => {
          if (this.count > 1) {
            this.btn_ver = true;
          } else {
            this.btn_ver = false;
          }
          res.forEach((el) => {
            this.extraInformation.total_evolucao_pendente = el.total_consultas;
            this.pendencies.push({
              patient: el.patient,
              email: el.email,
              date_at: moment(el.date_at).format("DD/MM/YYYY"),
              hour_at: el.hour_at,
              paymentform: el.paymentform,
              tipo_servico: el.servico,
              status: el.statusconsulta,
              id: el.id,
            });
          });
        });
    },
    detalhar(item) {
      this.$router.push({
        name: "PerfilConsultas",
        params: {
          id: item.id,
          voltar: "dashboard",
        },
      });
    },
  },
  mounted() {
    this.pendingQueries();
    this.bringOutstandingAmounts();
  },
};
</script>
<style scoped>
.card-body {
  font-size: 14px;
  font-weight: 400;
}
.div_cards {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 1em;
  margin-bottom: 2em;
}
.div_cards div {
  display: inline-block;
  border: 1px solid #ccc;
  padding: 0.1em 1.5em;
  /* flex-grow: 1; */
  width: 20%;
  position: relative;
}
.div-cards-value-evolution {
  width: 50% !important;
  height: 17vh;
  cursor: pointer;
  display: flex !important;
  place-content: center;
}

#rec {
  background-color: #203864 !important;
  width: 2px !important;
  position: absolute;
  left: 0px;
  bottom: 0px;
  padding: 6px;
  height: 80%;
}
.title {
  font-size: 35px;
  color: #666;
  transition: all 0.4s;
  font-weight: 600;
}
.div-checkbox-options {
  padding-left: 15px;
  display: grid;
  grid-template-columns: 1fr 1fr;
}
fieldset {
  position: absolute;
  text-align: center;
}
fieldset .extra-info-title {
  font-weight: 600;
  font-size: 25px;
}
</style>
